import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('processdelay').factory('ProcessDelayFilter', ProcessDelayFilterData);

    ProcessDelayFilterData.$inject = ['BATCH_PROCESS_DELAY_STATUS'];

    /* @ngInject */
    function ProcessDelayFilterData(BATCH_PROCESS_DELAY_STATUS) {
        ProcessDelayFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch
        };

        function ProcessDelayFilter(processDelayFilterData) {
            if (!processDelayFilterData) {
                this.buildEmpty();
            } else {
                this.build(processDelayFilterData);
            }
        }

        return ProcessDelayFilter;

        /**
         * Constructeur par defaut.
         */
        function buildEmpty() {
            this.batchId = null;
            this.principalId = null;
            this.ladProviderId = null;
            this.companyName = null;
            this.containerId = null;
            this.status = BATCH_PROCESS_DELAY_STATUS[0];
            this.reference = null;
            this.sentDateFrom = initialDateFrom();
            this.sentDateTo = initialDateTo();
            this.processedDateFrom = null;
            this.processedDateTo = null;
            this.sentTimeFrom = initialTimeFrom();
            this.sentTimeTo = initialTimeTo();
            this.processedTimeFrom = initialTimeFrom();
            this.processedTimeTo = initialTimeTo();
        }

        /**
         * Constructeur avec des données.
         */
        function build(processDelayFilterData) {
            this.batchId = processDelayFilterData.batchId || null;
            this.principalId = processDelayFilterData.principalId || null;
            this.companyName = processDelayFilterData.companyName || null;
            this.containerId = processDelayFilterData.containerId || null;
            this.ladProviderId = processDelayFilterData.ladProviderId;
            this.status = processDelayFilterData.status || BATCH_PROCESS_DELAY_STATUS[0];
            this.sentDateFrom = processDelayFilterData.sentDateFrom || null;
            this.sentDateTo = processDelayFilterData.sentDateTo || null;
            this.processedDateFrom = processDelayFilterData.processedDateFrom || null;
            this.processedDateTo = processDelayFilterData.processedDateTo || null;
            this.sentTimeFrom = processDelayFilterData.sentTimeFrom || initialTimeFrom();
            this.sentTimeTo = processDelayFilterData.sentTimeTo || initialTimeTo();
            this.processedTimeFrom = processDelayFilterData.processedTimeFrom || initialTimeFrom();
            this.processedTimeTo = processDelayFilterData.processedTimeTo || initialTimeTo();
        }

        /**
         * Préparation du filtre avant l'envoi vers le serveur.
         */
        function preparBeforeSearch(companySelected) {
            var clone = new ProcessDelayFilter(this);
            if (clone.status === BATCH_PROCESS_DELAY_STATUS[0]) {
                clone.statuses = _.tail(_.map(BATCH_PROCESS_DELAY_STATUS, 'key'));
            } else {
                clone.statuses = [clone.status.key];
            }
            if (this.sentDateFrom) {
                clone.sentDateFrom = new Date(
                    this.sentDateFrom.getFullYear(),
                    this.sentDateFrom.getMonth(),
                    this.sentDateFrom.getDate(),
                    clone.sentTimeFrom.getHours(),
                    this.sentTimeFrom.getMinutes()
                );
            }
            if (this.sentDateTo) {
                clone.sentDateTo = new Date(
                    this.sentDateTo.getFullYear(),
                    this.sentDateTo.getMonth(),
                    this.sentDateTo.getDate(),
                    this.sentTimeTo.getHours(),
                    this.sentTimeTo.getMinutes()
                );
            }
            if (this.processedDateFrom) {
                clone.updateDateFrom = new Date(
                    this.processedDateFrom.getFullYear(),
                    this.processedDateFrom.getMonth(),
                    this.processedDateFrom.getDate(),
                    this.processedTimeFrom.getHours(),
                    this.processedTimeFrom.getMinutes()
                );
            }
            if (this.processedDateTo) {
                clone.updateDateTo = new Date(
                    this.processedDateTo.getFullYear(),
                    this.processedDateTo.getMonth(),
                    this.processedDateTo.getDate(),
                    this.processedTimeTo.getHours(),
                    this.processedTimeTo.getMinutes()
                );
            }
            if (companySelected) {
                clone.companyName = companySelected.companyName;
            }
            delete clone.processedDateFrom;
            delete clone.processedDateTo;
            delete clone.sentTimeFrom;
            delete clone.sentTimeTo;
            delete clone.processedTimeFrom;
            delete clone.processedTimeTo;
            delete clone.status;
            return clone;
        }

        /**
         * initialisation de la borne inf de l'heure et de la minute.
         */
        function initialTimeFrom() {
            var time = new Date();
            time.setHours(0, 0, 0, 0);
            return time;
        }

        /**
         * initialisation de la borne sup de l'heure et de la minute.
         */
        function initialTimeTo() {
            var time = new Date();
            time.setHours(23, 59, 0, 0);
            return time;
        }

        /**
         * initialisation de la borne inf d'une date.
         */
        function initialDateFrom() {
            var date = new Date();
            date.setDate(date.getDate() - 7);
            return date;
        }

        /**
         * initialisation de la borne sup d'une date.
         */
        function initialDateTo() {
            var time = new Date();
            time.setHours(23, 59, 0, 0);
            return time;
        }
    }
})();
